import Vue from 'vue'
import VueToasted from 'vue-toasted'
Vue.use(VueToasted)

const DEFAULT_DURATION = 3500
const CLASS_NAME = 'app-toast-class'

export default {
  show (msg, opt) {
    return Vue.toasted.show(msg, {
      className: CLASS_NAME,
      duration: DEFAULT_DURATION
    })
  },
  info (msg, opt) {
    return Vue.toasted.info(msg, {
      icon: 'info',
      className: CLASS_NAME,
      duration: DEFAULT_DURATION
    })
  },
  success (msg, opt) {
    return Vue.toasted.success(msg, {
      icon: 'check',
      className: CLASS_NAME,
      duration: DEFAULT_DURATION
    })
  },
  warning (msg, opt) {
    return Vue.toasted.error(msg, {
      icon: 'warning',
      className: CLASS_NAME,
      duration: DEFAULT_DURATION
    })
  },
  error (msg, opt) {
    return Vue.toasted.error(msg, {
      icon: 'error',
      className: CLASS_NAME,
      duration: null,
      action: [
        {
          text: 'OK',
          onClick: (e, toastObject) => {
            toastObject.goAway(0)
          }
        }
      ]
    })
  }
}



// WEBPACK FOOTER //
// ./src/common/services/toastr.js